import React from 'react';

const SvgComponent = (props) => (
  <svg
    data-name="add circle active-layer"
    viewBox="0 0 18 18"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M7.52 4.66a.75.75 0 0 1 .75.75v3.1l.73.26 2.8.93 2.52.84a.74.74 0 0 1 .44.68v4a1.68 1.68 0 0 1-1.68 1.68h-4a2.59 2.59 0 0 1-1.88-.78l-3.8-3.8a.75.75 0 0 1 0-1.06.71.71 0 0 1 .49-.19.82.82 0 0 1 .58.24l.36.36 1.91 1.91V5.41a.75.75 0 0 1 .75-.75m0-1.12a1.87 1.87 0 0 0-1.83 1.87v5.45l-.36-.36a1.94 1.94 0 0 0-1.36-.5 1.83 1.83 0 0 0-1.25.49 1.87 1.87 0 0 0 0 2.64l3.8 3.8a3.73 3.73 0 0 0 2.59 1h4.05a2.8 2.8 0 0 0 2.8-2.8v-4a1.87 1.87 0 0 0-1.17-1.73l-2.56-.8-2.8-.93V5.41a1.87 1.87 0 0 0-1.88-1.87zM6.97 0h1.05v2.62H6.97zM2.12 4.22h2.62v1.05H2.12z" />
    <path d="M10.4 4.22h2.62v1.05H10.4zM3.539 1.603L4.28.861l1.853 1.853-.743.742zM8.992 2.713L10.845.86l.742.743-1.852 1.852z" />
  </svg>
);

export default SvgComponent;
